import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconAttachment } from '../../../base/icons/svg';
import Message from '../../../base/react/components/web/Message.web';
const useStyles = makeStyles()(theme => {
    return {
        attachments: {
            display: 'flex',
        },
        attachmentIcon: {
            marginRight: '8px'
        }
    };
});
export function renderNotificationMessageAttachments(text, number) {
    return (number || text) ? (React.createElement("div", null,
        (number && number > 0) ? (React.createElement(NotificationMessageAttachments, { number: number })) : null,
        text && (React.createElement("div", { className: 'notification-message' },
            React.createElement(Message, { text: text })))))
        : undefined;
}
export default function NotificationMessageAttachments({ number }) {
    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    return (React.createElement("div", { className: classes.attachments },
        React.createElement(Icon, { className: classes.attachmentIcon, size: 20, src: IconAttachment }),
        t('chat.andAttachments', { number })));
}
